import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { connect } from 'react-redux';
import { compose, branch, renderNothing } from 'recompose';
import { Grid, Panel, Alert } from 'react-bootstrap';

import { getEndDateApiFormat, getStartDateApiFormat } from '../selectors';
import { queryGetAllUserTimeEntryGroupsDataGQL } from '../graphql/AllUserTimeEntryGroupsApi';
import TrirTable from '../components/TrirTable';
import TrirSummary from '../components/TrirSummary';
import { getApiServerUrl } from '../../configuration/selectors';

const propTypes = exact({
  allUserTimeEntryGroups: PropTypes.array.isRequired,
  /* eslint-disable react/no-unused-prop-types */
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  /* eslint-enable react/no-unused-prop-types */
  summary: PropTypes.object.isRequired,
  apiServerUrl: PropTypes.string.isRequired,
});


const TrirView = (props) => {
  const {
    allUserTimeEntryGroups,
    summary,
    apiServerUrl,
    startDate,
    endDate,
  } = props;

  return (
    <Grid fluid>
      <Alert className="alert alert-danger">These totals are for employees that are required to submit timesheets and
        do not include salary employees that are not required to submit timesheets.
      </Alert>
      <Panel>
        <div className="panel-heading"><h2>Summary</h2></div>
        <div className="panel-body">
          <TrirSummary summary={summary} />
        </div>
      </Panel>
      <TrirTable
        apiStartDate={startDate}
        apiEndDate={endDate}
        apiServerUrl={apiServerUrl}
        allTimesheetsForAllUsers={allUserTimeEntryGroups}
      />
    </Grid>
  );
};


TrirView.propTypes = propTypes;

const mapStateToProps = (state) => {
  return {
    startDate: getStartDateApiFormat(state),
    endDate: getEndDateApiFormat(state),
    apiServerUrl: getApiServerUrl(state),
  };
};

const withRedux = connect(mapStateToProps, {});

const withNoStartOrEndDate = branch(
  (props) => { return !props.startDate || !props.endDate; },
  renderNothing,
);

const enhance = compose(
  withRedux,
  withNoStartOrEndDate,
  queryGetAllUserTimeEntryGroupsDataGQL,
);

export default enhance(TrirView);
